import { request } from '../../../foundation/data-access/request';
import { DataFeedInput } from '@server/data-feed/schemas/input.schema';
import { useNotifications } from '@client/foundation/notifications/notifications.hook';
import { useCallback } from 'react';

export const useFileUpload = () => {
  const { notify } = useNotifications();

  const uploadFile = useCallback(
    async (dataFeedInput: DataFeedInput, files?: File[]) => {
      try {
        // Create FormData object
        const formData = new FormData();

        // Append all the market config data
        Object.entries(dataFeedInput.marketConfig).forEach(([key, value]) => {
          if (value) {
            formData.append(key, value as string);
          }
        });

        // formData.append("test", []);

        formData.append('feedId', dataFeedInput.feedId);

        // Append all files if they exist
        if (files && files.length > 0) {
          files.forEach((file, index) => {
            formData.append('files', file);
            formData.append(
              `timeframes[${index}]`,
              JSON.stringify({
                timeframe: dataFeedInput.timeframes[index].timeframe
              })
            );
          });
        }

        const res = await request(`/rest/upload`, {
          method: 'POST',
          body: formData
        });

        if (!res.ok) {
          throw new Error('File upload failed.');
        }
      } catch (err) {
        console.error(err);
        notify({
          message: 'Error uploading file.',
          type: 'error'
        });
      }
    },
    [notify]
  );

  return { uploadFile };
};
export function extractSymbolAndTimeframe(filename: string) {
  // Capture the leading symbol and timeframe, ignore any extra suffixes before ".csv"
  const pattern = /^([A-Za-z0-9]+)_(\d+[mhdwM])(?:[ _].*)?\.csv$/;
  const match = filename.match(pattern);

  if (!match) {
    return { symbol: null, timeframe: null }; // or throw an error
  }

  const symbol = match[1]; // e.g., "BTCUSDT"
  const timeframe = match[2]; // e.g., "15m"

  return { symbol, timeframe };
}
